module.exports = __webpack_public_path__ + "static/img/vivo1.f2311c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/vivo/vivo1.png
// module id = E9T3
// module chunks = 0